var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.742 3.215h0C5.667 1.635 8.241.75 11 .75c2.759 0 5.333.886 7.258 2.465l.476-.58-.476.58c1.953 1.603 2.992 3.708 2.992 5.923 0 2.214-1.039 4.32-2.992 5.923h0c-1.925 1.58-4.5 2.465-7.258 2.465-.246 0-.496-.008-.746-.023a.75.75 0 00-.746.486 5.173 5.173 0 01-1.63 2.242h0c-.72.564-1.55.902-2.431.993a5.719 5.719 0 001.207-4.048.75.75 0 00-.448-.623c-1.587-.688-2.916-1.701-3.868-2.93C1.292 12.275.75 10.725.75 9.139c0-2.215 1.039-4.32 2.992-5.923zm1.38 18.382s0 0 0 0 0 0 0 0h0z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
export default SvgMessageSolid;